<template>


	<div class="relative f fy">



		<el-table class="" :data="records" border stripe>

			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="username" label="username">
			</el-table-column>

			<el-table-column prop="role" label="role">
			</el-table-column>




			<el-table-column label="operate">
				<template slot="header">

					<div class="relative cm-0-5">
						<el-button type="primary" size="mini" @click="load()">refresh</el-button>
						<el-button type="primary" size="mini" @click="create()">
							create
						</el-button>
					</div>
				</template>
				<template slot-scope="scope">
					<div class="relative cm-0-5">

						<el-button type="primary" size="mini" @click="update(scope.row)">
							update
						</el-button>
						<el-button type="primary" size="mini" @click="userStation(scope.row)">
							station
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="relative text-center mt-2" background layout="prev, pager, next, total" :total="total"
			:page-size="size" :current-page="page" @current-change="load">
		</el-pagination>
	</div>

</template>

<script>
	import OptionTag from '@/components/OptionTag'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			OptionTag,
		},
		data() {
			return {
				places: [
					'HOME_SWIPER',
					'HOME_MENU',
				],
				form: {},
				records: [],
				total: 0,
				pages: 0,
				size: 10,
				page: 1,
				params: {},

			}
		},
		mounted() {
			this.search();
		},
		methods: {
			search() {
				this.params = {
					...this.form,
					...this.propParams
				}
				this.load(1);
			},
			load(page) {
				page = page || this.page || 1;
				console.log(this.options)
				request({
					loading: true,
					url: '/api/user/selectUserPage',
					data: {
						...this.params,
						role: 'STATION_ADMIN',
						page,
					},
					success: resp => {
						this.records = resp.data.records;
						this.total = resp.data.total;
						this.pages = resp.data.pages;
						this.page = page;
					}
				})

			},

			create() {
				dialogs.open('AdminForm', {
					mode: 'create',
					title: 'create admin',
					propForm: {
						stationId: this.propParams.stationId
					},
					success: this.load
				})
			},

			update(row) {
				dialogs.open('AdminForm', {
					mode: 'update',
					title: 'editor admin',
					propForm: {
						...row
					},
					success: this.load
				})
			},

			userStation(row) {
				dialogs.open('UserStationTable', {
					propParams: {
						userId: row.id
					}
				})
			}


		}
	}
</script>

<style>




</style>